// Labels for the Account Management page (/accountManagement).
// Language keys match LanguageContext: 0 = English, 1 = Traditional Chinese, 2 = Simplified Chinese.
// Status snackbars for delete / update / admin reuse `userDetailsLabels`
// in ./adminPanelLabels.js — they are already translated.

export const accountLabels = {
  title: {
    0: "Account Management",
    1: "帳戶管理",
    2: "账户管理",
  },
  subtitle: {
    0: "Create and delete assessment accounts. To check who has finished or download reports, use Admin Panel.",
    1: "建立及刪除評估帳戶。如需查看完成狀況或下載報告，請使用管理版面。",
    2: "建立及删除评估账户。如需查看完成状况或下载报告，请使用管理版面。",
  },

  // ---- create panel ----
  createAccount: {
    0: "Create account",
    1: "建立帳戶",
    2: "建立账户",
  },
  createSubtitle: {
    0: "You set the password. Nothing is emailed, so pass it to the person yourself.",
    1: "由你設定密碼。系統不會發送電郵，請自行將密碼交給該用戶。",
    2: "由你设定密码。系统不会发送电邮，请自行将密码交给该用户。",
  },
  englishName: {
    0: "English Name",
    1: "英文姓名",
    2: "英文姓名",
  },
  chineseName: {
    0: "Chinese Name",
    1: "中文姓名",
    2: "中文姓名",
  },
  email: {
    0: "Email",
    1: "電郵",
    2: "电邮",
  },
  emailHint: {
    0: "Also the login ID and the report filename.",
    1: "同時作為登入帳號及報告檔案名稱。",
    2: "同时作为登录账号及报告文件名称。",
  },
  group: {
    0: "Group",
    1: "組別",
    2: "组别",
  },
  groupHint: {
    0: "Existing or new.",
    1: "可選擇現有或新增。",
    2: "可选择现有或新增。",
  },
  grantAdmin: {
    0: "Grant admin access",
    1: "授予管理員權限",
    2: "授予管理员权限",
  },
  grantAdminHint: {
    0: "Can create and delete accounts",
    1: "可建立及刪除帳戶",
    2: "可建立及删除账户",
  },
  password: {
    0: "Password",
    1: "密碼",
    2: "密码",
  },
  passwordHint: {
    0: "The person logs in with this.",
    1: "該用戶以此密碼登入。",
    2: "该用户以此密码登录。",
  },
  generate: {
    0: "Generate",
    1: "隨機產生",
    2: "随机生成",
  },
  showPassword: {
    0: "Show password",
    1: "顯示密碼",
    2: "显示密码",
  },
  hidePassword: {
    0: "Hide password",
    1: "隱藏密碼",
    2: "隐藏密码",
  },
  passwordNote: {
    0: "Passwords are never emailed. Write this one down before you create the account, then give it to the person directly. You cannot read it back afterwards, only replace it.",
    1: "系統不會以電郵發送密碼。請在建立帳戶前記下密碼，並直接交給該用戶。建立後將無法查看，只能重新設定。",
    2: "系统不会以电邮发送密码。请在建立账户前记下密码，并直接交给该用户。建立后将无法查看，只能重新设定。",
  },
  clear: {
    0: "Clear",
    1: "清除",
    2: "清除",
  },
  create: {
    0: "Create account",
    1: "建立帳戶",
    2: "建立账户",
  },

  // ---- validation ----
  emailRequired: {
    0: "Email is required",
    1: "必須填寫電郵",
    2: "必须填写电邮",
  },
  groupRequired: {
    0: "Group is required",
    1: "必須填寫組別",
    2: "必须填写组别",
  },
  passwordRequired: {
    0: "Password is required",
    1: "必須填寫密碼",
    2: "必须填写密码",
  },
  // bcrypt hashes at most 72 bytes, so the backend rejects anything longer.
  passwordTooLong: {
    0: "Password is too long (max 72 bytes)",
    1: "密碼過長（上限 72 位元組）",
    2: "密码过长（上限 72 字节）",
  },

  // ---- accounts list ----
  existingAccounts: {
    0: "Existing accounts",
    1: "現有帳戶",
    2: "现有账户",
  },
  searchPlaceholder: {
    0: "Search email or name",
    1: "搜尋電郵或姓名",
    2: "搜寻电邮或姓名",
  },
  allGroups: {
    0: "All groups",
    1: "所有組別",
    2: "所有组别",
  },
  name: {
    0: "Name",
    1: "姓名",
    2: "姓名",
  },
  role: {
    0: "Role",
    1: "角色",
    2: "角色",
  },
  roleUser: {
    0: "User",
    1: "用戶",
    2: "用户",
  },
  roleAdmin: {
    0: "Admin",
    1: "管理員",
    2: "管理员",
  },
  you: {
    0: "You",
    1: "你",
    2: "你",
  },
  justCreated: {
    0: "Just created",
    1: "剛建立",
    2: "刚建立",
  },
  accounts: {
    0: "accounts",
    1: "個帳戶",
    2: "个账户",
  },
  // English is the only one of the three that pluralises.
  account: {
    0: "account",
    1: "個帳戶",
    2: "个账户",
  },
  manage: {
    0: "Manage",
    1: "管理",
    2: "管理",
  },
  actions: {
    0: "Actions",
    1: "操作",
    2: "操作",
  },
  noAccounts: {
    0: "No accounts match your search.",
    1: "沒有符合搜尋條件的帳戶。",
    2: "没有符合搜寻条件的账户。",
  },
  cannotDeleteSelf: {
    0: "You cannot delete your own account",
    1: "你不能刪除自己的帳戶",
    2: "你不能删除自己的账户",
  },

  // ---- delete dialog ----
  deleteTitle: {
    0: "Delete account?",
    1: "刪除帳戶？",
    2: "删除账户？",
  },
  deleteLead: {
    0: "This permanently deletes",
    1: "此操作將永久刪除",
    2: "此操作将永久删除",
  },
  deleteIrreversible: {
    0: "It cannot be undone.",
    1: "此操作無法復原。",
    2: "此操作无法复原。",
  },
  whatGetsErased: {
    0: "What gets erased",
    1: "將被刪除的資料",
    2: "将被删除的资料",
  },
  erasedLogin: {
    0: "The login for",
    1: "以下用戶的登入帳號：",
    2: "以下用户的登录账号：",
  },
  erasedAnswers: {
    0: "Saved assessment answers",
    1: "已儲存的評估答案",
    2: "已储存的评估答案",
  },
  erasedFiles: {
    0: "Raw score and report files on the server",
    1: "伺服器上的原始分數及報告檔案",
    2: "服务器上的原始分数及报告文件",
  },
  typeToConfirm: {
    0: "Type the email address to confirm.",
    1: "請輸入該電郵地址以確認。",
    2: "请输入该电邮地址以确认。",
  },
  emailAddress: {
    0: "Email address",
    1: "電郵地址",
    2: "电邮地址",
  },

  // ---- manage dialog ----
  manageTitle: {
    0: "Manage account",
    1: "管理帳戶",
    2: "管理账户",
  },
  changeGroup: {
    0: "Group",
    1: "組別",
    2: "组别",
  },
  save: {
    0: "Save",
    1: "儲存",
    2: "储存",
  },
  passwordSection: {
    0: "Password",
    1: "密碼",
    2: "密码",
  },
  newPassword: {
    0: "New password",
    1: "新密碼",
    2: "新密码",
  },
  setPassword: {
    0: "Set password",
    1: "設定密碼",
    2: "设定密码",
  },
  newPasswordHint: {
    0: "Replaces the current password straight away. Tell the person their new one.",
    1: "將立即取代現有密碼，請通知該用戶新密碼。",
    2: "将立即取代现有密码，请通知该用户新密码。",
  },
  adminSection: {
    0: "Admin access",
    1: "管理員權限",
    2: "管理员权限",
  },
  adminOn: {
    0: "On — can create and delete accounts.",
    1: "已開啟 — 可建立及刪除帳戶。",
    2: "已开启 — 可建立及删除账户。",
  },
  adminOff: {
    0: "Off — cannot see other people's accounts or reports.",
    1: "已關閉 — 不能查看其他用戶的帳戶或報告。",
    2: "已关闭 — 不能查看其他用户的账户或报告。",
  },
  close: {
    0: "Close",
    1: "關閉",
    2: "关闭",
  },

  // ---- snackbars ----
  createStatus: {
    success: {
      0: "Account created.",
      1: "已建立帳戶。",
      2: "已建立账户。",
    },
    failed: {
      0: "Failed to create account, please try again!",
      1: "建立帳戶失敗，請重試！",
      2: "建立账户失败，请重试！",
    },
  },
  passwordStatus: {
    success: {
      0: "Password updated.",
      1: "密碼已更新。",
      2: "密码已更新。",
    },
    failed: {
      0: "Failed to update password, please try again!",
      1: "更新密碼失敗，請重試！",
      2: "更新密码失败，请重试！",
    },
  },
};
